import React from 'react';

import Select from 'react-select';

import sireVettingType from '@/data/sireVettingType';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectSireVettingType: React.FC<any> = ({ name, value, defaultValue, placeholder, handleChange, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={sireVettingType.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={sireVettingType}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectSireVettingType;
